export default __webpack_public_path__ + "static/media/womenCoat.58be6893.svg";